import styled, { css, FlattenSimpleInterpolation } from 'styled-components';
import { Tag } from 'antd';

export const StyledCheckableTag = styled(Tag.CheckableTag)<{ $disabled?: boolean }>`
  border: none;
  margin: 0;
  padding: 6px ${({ theme: { kcc } }): string => kcc.spacing.BASE};
  font-size: ${({ theme: { kcc } }): number => kcc.typography.FONT_SIZE.BASE}px;
  background-color: ${({ theme: { kcc } }): string => kcc.colors.GRAY_300};
  font-weight: ${({ theme: { kcc } }): number => kcc.typography.FONT_WEIGHT.EXTRA_BOLD};

  &.ant-tag-checkable-checked,
  &.ant-tag-checkable-checked:hover {
    background-color: ${({ theme: { kcc } }): string => kcc.colors.BLACK};
    color: ${({ theme: { kcc } }): string => kcc.colors.WHITE};
  }

  &.ant-tag-checkable:not(.ant-tag-checkable-checked):hover {
    background-color: ${({ theme: { kcc } }): string => kcc.colors.GRAY_300};
  }

  ${({ $disabled, theme: { kcc } }): FlattenSimpleInterpolation | false =>
    Boolean($disabled) &&
    css`
      &&,
      &&.ant-tag-checkable-checked {
        background-color: ${kcc.colors.GRAY_200};
        color: ${kcc.colors.GRAY_400};
        cursor: not-allowed;
      }
    `}
`;
